<script>
    import { intcomma } from 'journalize';
    import { calif_pesticides } from './calif_pesticides';

    export let modalData;
</script>
<table class="dg-table">
  <thead>
    <tr>
      <th class="text-left" role="columnheader">Name</th>
      <th class="text-center" role="columnheader">Concentration (parts per billion)</th>
      <th class="text-center" role="columnheader">Times over testing threshold</th>
    </tr>
  </thead>
  <tbody>
    {#each Object.entries(modalData.pesicidesList[0]) as [key, value]}
      <tr class={calif_pesticides.includes(key) ? 'ca' : 'epa'}>
        <th class="text-left" role="rowheader">{key}</th>
        {#each Object.entries(value) as [key, value]}
          <td class="text-center">{intcomma(value)}</td>
        {/each}
      </tr>
    {/each}
  </tbody>
</table>